
import React from 'react';
import { Button } from '@/components/ui/button';
import { TrendingUp, BarChart2, LineChart } from 'lucide-react';
import { Link } from 'react-router-dom';

const StockInvestmentSection = () => {
  return (
    <section className="relative py-16 md:py-24">
      {/* Background image */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url("/lovable-uploads/6d4a0f9c-5920-4c0f-a9c4-c07f8f81a4a4.png")' }}
      ></div>
      
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="section-title mb-6 text-white">Investissement en Actions Boursières</h2>
          <div className="w-16 h-1 bg-patrimoine-gold mx-auto mb-6"></div>
          <p className="text-lg md:text-xl text-white mb-8">
            Diversifiez votre patrimoine avec des stratégies d'investissement boursier personnalisées pour vos objectifs à long terme.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-lg p-8 transition-transform hover:translate-y-[-5px]">
            <div className="rounded-full bg-patrimoine-gold/20 p-3 inline-flex mb-6">
              <TrendingUp className="h-8 w-8 text-black" />
            </div>
            <h3 className="text-2xl font-serif font-semibold mb-4">Analyse des Marchés</h3>
            <p className="text-patrimoine-muted">
              Notre équipe d'experts analyse continuellement les tendances du marché pour identifier les meilleures opportunités d'investissement adaptées à votre profil de risque.
            </p>
          </div>
          
          <div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-lg p-8 transition-transform hover:translate-y-[-5px]">
            <div className="rounded-full bg-patrimoine-gold/20 p-3 inline-flex mb-6">
              <BarChart2 className="h-8 w-8 text-black" />
            </div>
            <h3 className="text-2xl font-serif font-semibold mb-4">Portefeuilles Diversifiés</h3>
            <p className="text-patrimoine-muted">
              Nous construisons des portefeuilles équilibrés comprenant des actions françaises et internationales, des ETF, et des fonds d'investissement pour maximiser vos rendements.
            </p>
          </div>
          
          <div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-lg p-8 transition-transform hover:translate-y-[-5px]">
            <div className="rounded-full bg-patrimoine-gold/20 p-3 inline-flex mb-6">
              <LineChart className="h-8 w-8 text-black" />
            </div>
            <h3 className="text-2xl font-serif font-semibold mb-4">Suivi Personnalisé</h3>
            <p className="text-patrimoine-muted">
              Bénéficiez d'un suivi régulier de vos investissements avec des rapports détaillés et des ajustements stratégiques pour optimiser votre portefeuille.
            </p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/bilan-patrimonial">
            <Button className="cta-button font-medium">Planifier une consultation</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default StockInvestmentSection;
